// Suppress Workbox console logs in browser
(function() {
  if (typeof window !== 'undefined') {
    const originalLog = console.log;
    const originalWarn = console.warn;
    const originalInfo = console.info;
    const originalDebug = console.debug;
    
    // Filter out workbox messages
    console.log = function(...args) {
      if (args[0] && typeof args[0] === 'string' && args[0].includes('workbox')) {
        return; // Suppress workbox logs
      }
      originalLog.apply(console, args);
    };
    
    console.warn = function(...args) {
      if (args[0] && typeof args[0] === 'string' && args[0].includes('workbox')) {
        return; // Suppress workbox warnings
      }
      originalWarn.apply(console, args);
    };
    
    console.info = function(...args) {
      if (args[0] && typeof args[0] === 'string' && args[0].includes('workbox')) {
        return; // Suppress workbox info
      }
      originalInfo.apply(console, args);
    };
    
    console.debug = function(...args) {
      if (args[0] && typeof args[0] === 'string' && args[0].includes('workbox')) {
        return; // Suppress workbox debug
      }
      originalDebug.apply(console, args);
    };
  }
})();
